// extracted by mini-css-extract-plugin
module.exports = {"project":"Projects_project__1dlEA"};